/**
 * The deeds a condition can wait on, named the way somebody would say them.
 *
 * By the skill it took rather than by a word like "made": cook five fish, smith
 * four bars, light a fire. Building is not among them because the only thing a
 * player builds is a fire, and that is firemaking.
 */
export const DEEDS: { deed: string; label: string }[] = [
  { deed: 'cooking', label: 'Cooked' },
  { deed: 'smithing', label: 'Smithed' },
  { deed: 'crafting', label: 'Crafted' },
  { deed: 'firemaking', label: 'Lit' },
  { deed: 'woodcutting', label: 'Chopped' },
  { deed: 'mining', label: 'Mined' },
  { deed: 'fishing', label: 'Caught' },
  { deed: 'used', label: 'Used' },
];
